export const stripQueryStringFromUrl = (url: string): string => {
    return url.split("?")[0];
};
